import React from 'react';

const Title = () => {
    return <title>Developer Portfolio | React, Typescript, Material-UI, and Gatsby.</title>
}

export default Title;